<template>
  <v-card class="mt-5" outlined rounded="lg">
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th
              v-for="(item, index) in headers"
              :key="index"
              class="text-left"
            >
              {{item.text}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in loanDistributions"
            :key="index"
          >
            <td>
              {{`${item.person?.firstName} ${item.person?.lastName}`}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.totalAssets || 0)}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.totalLiabilities || 0)}}
            </td>
            <td>
              {{asMoney(item.affordabilityResults?.networth || 0)}}
            </td>
            <td>
              {{asPercent(item.affordabilityResults?.netRatio || 0)}}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th></th>
            <th
              v-for="(value, key) in summations"
              :key="key"
              class="text-left"
            >
              <span v-if="key === 'averageNetRatio'">{{asPercent(value)}}</span>
              <span v-else>{{asMoney(value)}}</span>
            </th>
          </tr>
        </tfoot>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
export default {
  mixins: [PageMixin],
  data() {
    return {
      /** @type {import('vuetify').DataTableHeader[]}*/
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Assets', value: 'assets', sortable: false },
        { text: 'Liabilities', value: 'liabilities', sortable: false },
        { text: 'Net Worth', value: 'net', sortable: false },
        { text: 'Net Ratio', value: 'netRatio', sortable: false }
      ]
    }
  },

  props: {
    loanDistributions: {
      type: Array,
      default: () =>([])
    }
  },
  
  computed: {
    summations: function() {
      return this.loanDistributions.reduce((acc, cur) => {
         const { affordabilityResults } = cur;
         acc.assetsSummation += affordabilityResults.totalAssets; 
         acc.liabilitySummation += affordabilityResults.totalLiabilities;
         acc.averageNetworth += (affordabilityResults.networth || 0) / this.loanDistributions.length;
         acc.averageNetRatio += (affordabilityResults.netRatio || 0) / this.loanDistributions.length;
         return acc; 
      }, {
        assetsSummation: 0,
        liabilitySummation: 0,
        averageNetworth: 0,
        averageNetRatio: 0,
      })
    }
  }
};
</script>

<style lang="scss" scoped></style>
